/** Shared alert limits for chart AI context and command guardrails. */
export const MAX_ACTIVE_ALERTS = 50
